import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import { Fragment } from 'react';
import { Typography } from '@material-ui/core';
import EstadosChequesSelector from '../../UI/EstadosChequesSelector/EstadosChequesSelector';
import Button from '../../UI/Button/Button';
import DeleteableItem from '../../UI/DeleteableItem/DeleteableItem';
import Spinner from '../../UI/Spinner/Spinner';
import classes from './ChequesValorEstado.css';
import { compareByAsc } from '../../../assets/shared/sorting';

const ChequesValorEstado = (props) => {
  const { estados, onLoadEstados, onChequesValorEstadoLoad, onPostValoresEstados, onCloseModal } = props;
  const [valoresEstadosLocal, setValoresEstadosLocal] = useState({
    valoresTerceros: [],
    rechazadosTerceros: [],
    valoresPropios: []
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (estados.length === 0) {
      onLoadEstados();
    }
    setLoading(true);
    onChequesValorEstadoLoad(false, (valoresEstadosTerceros) => {
      let formatValoresEstados = { valoresTerceros: [], rechazadosTerceros: [], valoresPropios: [] };
      formatValoresEstados.valoresTerceros = valoresEstadosTerceros.valores;
      formatValoresEstados.rechazadosTerceros = valoresEstadosTerceros.rechazados || [];
      onChequesValorEstadoLoad(true, (valoresEstadosPropios) => {
        formatValoresEstados.valoresPropios = valoresEstadosPropios.valores || [];
        setValoresEstadosLocal(formatValoresEstados);
        setLoading(false);
      });
    });
  }, []);

  const [addEstadoLoading, setAddEstadoLoading] = useState(false);

  const addValoresEstadosLocal = (index, key, estado) => {
    if (!estado) {
      return;
    }
    setAddEstadoLoading(true);
    valoresEstadosLocal[key][index].estados.push(estado);
    setTimeout(() => {
      setAddEstadoLoading(false);
    }, 200);
  };

  const onSetEstadoSelected = (key, index, estado) => {
    const estadoActual = estadoSelected[key];
    estadoActual[index] = estado;
    setEstadoSelected({ ...estadoSelected, [key]: estadoActual });
  };

  const verifyExistEstado = (key, index, estado) => {
    
    if (estado ) {
      return valoresEstadosLocal[key][index].estados.some((est) => {
        return est.id_estado === estado.id_estado;
      });
    }
  };

  const buildValoresEstadosComponent = (key, title) => {
    return valoresEstadosLocal[key].map((valorEstado, index) => {
      return (
        <div key={index} className={classes.ChequesValorEstadoContainer}>
          {index === 0 && buildTitleAndSubtitle(title)}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" style={{ minWidth: '150px', fontSize: '1em' }}>
              {valorEstado.nombre}
            </Typography>
            <EstadosChequesSelector
              onChangeEstado={(estado) => onSetEstadoSelected(key, index, estado)}
              flexChangeEstados={addEstadoLoading}
            />
            <Button
              disabled={verifyExistEstado(key, index, estadoSelected[key][index])}
              size="small"
              style={{ fontSize: 'smaller' }}
              onClick={() => addValoresEstadosLocal(index, key, estadoSelected[key][index])}
            >
              + Agregar
            </Button>
            {buildEstados(key, index)}
            {addEstadoLoading && <Spinner personalSize="10px" />}
          </div>
        </div>
      );
    });
  };

  const buildTitleAndSubtitle = (title) => (
    <Fragment>
      <Typography variant="h5">{title}</Typography>
      <Typography variant="caption">Seleccione los estados correspondientes a cada valor</Typography>
    </Fragment>
  );

  const removeEstado = (key, index, estado) => {
    const removeIndex = valoresEstadosLocal[key][index].estados.findIndex((est) => est.id_estado === estado.id_estado);
    if (removeIndex !== -1) {
      setAddEstadoLoading(true);

      valoresEstadosLocal[key][index].estados.splice(removeIndex, 1);
      setTimeout(() => {
        setAddEstadoLoading(false);
      }, 200);
    }
  };

  const buildEstados = (key, index) => {
    return (
      <div className={classes.EstadosContainer}>
        {valoresEstadosLocal[key][index].estados
          .sort((a, b) => compareByAsc(a, b, 'nombre'))
          .map((estado, estadoIndex) => (
            <DeleteableItem key={estadoIndex} text={estado.nombre} onClick={() => removeEstado(key, index, estado)} />
          ))}
      </div>
    );
  };

  const [estadoSelected, setEstadoSelected] = useState({
    valoresTerceros: {},
    rechazadosTerceros: {},
    valoresPropios: {}
  });

  const [loadingPost, setLoadingPost] = useState(false);

  const onGuardarCambiosClick = () => {
    const chequesTerceros = {
      valores: valoresEstadosLocal.valoresTerceros,
      rechazados: valoresEstadosLocal.rechazadosTerceros
    };

    const chequesPropios = {
      valores: valoresEstadosLocal.valoresPropios,
      rechazados: []
    };

    onPostValoresEstados(chequesTerceros, false, () => {
      //post cheques propios
      onPostValoresEstados(chequesPropios, true, () => {
        setLoadingPost(true);
        onCloseModal();
      });
    });
  };

  return loading ? (
    <div style={{ margin: '20px' }}>
      <Spinner />
    </div>
  ) : (
    <div style={{ marginTop: '-20px' }}>
      {buildValoresEstadosComponent('valoresTerceros', 'Cheques terceros', valoresEstadosLocal.valoresTerceros)}
      {buildValoresEstadosComponent('rechazadosTerceros', 'Cheques rechazados', valoresEstadosLocal.rechazadosTerceros)}
      {buildValoresEstadosComponent('valoresPropios', 'Cheques emitidos', valoresEstadosLocal.valoresPropios)}
      <div className={classes.GuardarCambiosContainer}>
        <Button
          size="small"
          style={{ fontSize: 'smaller' }}
          onClick={() => onGuardarCambiosClick()}
          disabled={loadingPost}
        >
          Guardar cambios
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loadingEstados: state.configuraciones.loadEstadosCheques.loading,
    estados: state.configuraciones.loadEstadosCheques.estados
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChequesValorEstadoLoad: (propios, success) => dispatch(actions.loadChequesValorEstado({ propios, success })),
    onLoadEstados: () => dispatch(actions.loadEstadosCheques()),
    onPostValoresEstados: (valoresYEstados, propios, success, error) =>
      dispatch(actions.postChequesValorEstado(valoresYEstados, propios, undefined, success, error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChequesValorEstado);
